import {
    i18n,
} from '@/plugins/vuei8n'

const localState = {
    isShowModal: false,
    list: null,
    filteredList: null,
    office: {
        address: null,
        radius: null,
        polygon: null,
        latitude: null,
        longitude: null,
    },
}

const mutations = {
    setState: (state, {
        key,
        data,
    }) => {
        state[key] = data
    },
    setRadius: (state, v) => {
        state.office.radius = v
    },
    setPolygon: (state, v) => {
        state.office.polygon = v
    },
    setFilteredList: (state, v) => {
        state.filteredList = v.map((item) => ({
            id: item.id,
            text: item.address,
        }))
    },
}

const actions = {
    async fetch({
        commit,
    }) {
        try {
            const response = await this.$api.offices.fetch()
            commit('setState', {
                key: 'list',
                data: response.data.data,
            })
            commit('setFilteredList', response.data.data || [])
        } catch (err) {
            console.log(err)
        }
    },
    async add(_, data) {
        const response = await this.$api.offices.add(data)
        return response.status === 201
    },
    async update(_, data) {
        const response = await this.$api.offices.update(data.id, data)
        return response.status === 200
    },
    async remove(_, id) {
        const response = await this.$api.offices.remove(id)
        return response.status === 200
    },
}

const getters = {
    isShowModal: (state) => state.isShowModal,
    list: (state) => state.list,
    office: (state) => state.office,
    filteredListAll: (state) => {
        const data = Array.from(state.filteredList)

        data.unshift({
            id: 'list',
            text: i18n.t('listsHeader.all'),
        })

        data.unshift({
            id: 'all',
            text: i18n.t('forms.default'),
        })

        return data
    },
    filteredList: (state) => state.filteredList,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
